import { HashtagSourcesApiResponse, StoryApiResponse } from 'api/api.types';
import { getHashtagApiResponse } from 'api/Hashtag';
import { GetServerSideProps, NextPage } from 'next';
import ErrorPage from 'src/components/error/ErrorPage';
import * as React from 'react';
import PaginatedTopicPage from 'src/page-components/topic/PaginatedTopicPage';

interface TopicPaginatedPageProps {
  topicTag?: string;
  hashtagApi?: HashtagSourcesApiResponse | null;
  stories?: StoryApiResponse[] | null;
}

const TopicPaginatedDynamicPage: NextPage<TopicPaginatedPageProps> = ({
  topicTag,
  hashtagApi,
}) => {
  if (!topicTag || !hashtagApi) return <ErrorPage />;

  return <PaginatedTopicPage topicTag={topicTag} hashtagApi={hashtagApi} />;
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  if (!params) return { props: {} };

  if (params && parseInt(params.page as string) === 1) {
    return {
      redirect: {
        destination: '/topic/' + params.hashTag,
        permanent: true,
      },
    };
  }

  if (!parseInt(params?.page as string)) {
    return { notFound: true };
  }

  const topicTag = `${params.hashTag}`;
  let hashtagApi = null;

  if (!topicTag) {
    return { props: {} };
  }

  try {
    hashtagApi = await getHashtagApiResponse({
      name: topicTag,
      limit: 10,
      offset: (parseInt(params?.page as string) - 1) * 10 + 5,
    });
  } catch (_) {
    return { notFound: true };
  }

  if (!hashtagApi) {
    return { notFound: true };
  }

  // Return 404 for empty pages
  if (!hashtagApi.objects.length) {
    return { notFound: true };
  }

  if (topicTag !== hashtagApi.hashtag) {
    //Redirect to the lowercase URL
    return {
      redirect: {
        destination: `/topic/${hashtagApi.hashtag}/${params?.page}`,
        statusCode: 301,
      },
    };
  }

  return {
    props: {
      topicTag,
      hashtagApi,
    },
  };
};

export default TopicPaginatedDynamicPage;
